import fetch from 'isomorphic-fetch';
// import _includes from 'lodash/includes';

const Method = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE'
};

const handleErrors = (response, errorPropName = 'statusText') => {
  if (!response.ok) {
    const error = new Error(response[errorPropName]);
    error.response = response;
    throw error;
  }
  return response;
};

// new handleErrors
// const handleErrors = ([ok, response]) => {
//   console.log('handle errors');
//   if (!ok) {
//     const errorMessage = (response.error && response.error.message) || 'An error has occurred';
//     const error = new Error(errorMessage);
//     error.response = response;
//     throw error;
//   }
//   return response;
// };

// const handlePromise = (response) => {
//   console.log('handle promise');
//   const contentType = response.headers && response.headers.get('Content-Type');
//   if (_includes(contentType, 'application/json')) {
//     return Promise.all([response.ok, response.json()]);
//   }
//   return Promise.all([response.ok, response.text()]);
// };

// new request
// const request = (url, options) => (
//   fetch(url, options)
//     .then(handlePromise)
//     .then(handleErrors)
// );

// old request
const request = (url, options, returnType) => (
  fetch(url, options)
    .then(handleErrors)
    .then((response) => {
      if (returnType === 'text') {
        return response.text();
      }
      // TODO: look into adding check for response.headers.get('content-type')
      // better to check if contentType.includes('application/json') rather than
      // getting Unexpected end of json error
      return response.json();
    })
);

const get = (url, options = {}, headers = {}, returnType = 'json') => {
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  const finalOptions = {
    method: Method.get,
    credentials: 'same-origin',
    headers: finalHeaders,
    ...options
  };

  return request(url, finalOptions, returnType);
};

const post = (url, body = {}, options = {}, headers = {}, returnType = 'json') => {
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  const finalBody = JSON.stringify(body);
  const finalOptions = {
    method: Method.post,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders,
    ...options
  };

  return request(url, finalOptions, returnType);
};

const put = (url, body = {}, options = {}, headers = {}, returnType = 'json') => {
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  const finalBody = JSON.stringify(body);
  const finalOptions = {
    method: Method.put,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders,
    ...options
  };

  return request(url, finalOptions, returnType);
};

const deleteMethod = (url, body = {}, options = {}, headers = {}, returnType = 'json') => {
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  const finalBody = JSON.stringify(body);
  const finalOptions = {
    method: Method.delete,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders,
    ...options
  };
  return request(url, finalOptions, returnType);
};

const ApiService = {
  request,
  get,
  post,
  put,
  delete: deleteMethod,
  handleErrors
};

export default ApiService;



// WEBPACK FOOTER //
// ./src/util/api.js